module.exports = __webpack_public_path__ + "img/mask-left.bbdcdd08.png";